import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'
import { FlexWrapper } from 'lib/ui/components'
import { link } from 'app/sofia/resources/theme/css'
import { BREAKPOINT } from 'app/sofia/resources/constants'

export const Wrapper = styled.div<any>`
  > div {
    &:first-child {
      p {
        margin-top: 0;
      }
    }
  }

  input {
    border-radius: 4px;
    height: 40px;
    width: 50px;
    border: 1px solid ${props => props.theme.palette.general.greyLight};
    text-align: center;
    font: ${font('default', 'normal', '20px/1')};
    margin-right: 10px;
    box-sizing: border-box;
  }

  p,
  label {
    font-size: ${props => props.isLivBrite ? '20px' : '18px'};
  }

  a {
    ${link}
  }

  .customize {
    border: 0;
    color: ${props => props.theme.palette.primary.alphaDark};
    font: ${font('default', 'bold', '17px/1')};
    font-size: ${props => props.isLivBrite && '20px'};

    :hover {
      color: ${props => props.theme.palette.primary.alpha};
    }
  }

  strong {
    font-weight: bold;
  }
`

export const QtyWrapper = styled.div`
  padding: 10px 0 5px;

  > label {
    display: inline-block !important;
    font: ${font('default', 'normal', '16px/1')} !important;
  }

  .input-range {
    height: 7px;
    background-color: ${props => props.theme.palette.general.light};
    box-shadow: ${props => props.theme.palette.general.boxShadow};
    width: 100%;
    display: inline-block;
    margin-bottom: 20px;

    @media (max-width: ${BREAKPOINT.MD}) {
      margin-bottom: 15px;
    }

    &__label {
      display: none;
    }

    &__slider {
      width: 14px;
      height: 14px;
      background-color: ${props => props.theme.palette.primary.alphaDark};
      border: 5px solid ${props => props.theme.palette.general.light};
      box-shadow: ${props => props.theme.palette.general.boxShadow};
      top: -4px;
    }

    &__track {
      background-color: ${props => props.theme.palette.general.light};
    }
  }
`

export const Item = styled.div<any>`
  text-align: center;
  font: ${font('default', 'normal', '14px/1')};
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  box-shadow: inset 0 0 0 2px ${props => props.theme.palette.general.greyLight};
  color: ${props => props.theme.palette.general.textColor};
  overflow: hidden;
  margin: 5px;
  min-width: 100px;
  border: ${props => props.isLivBrite ? '5px' : '3px'} solid transparent;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > div {
    padding: 10px 8px;
  }

  &:hover,
  &.selected {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
    border-color: ${props => props.theme.palette.primary.beta};
    background: ${props => props.theme.productSelector.reviewBgColor};

    .item__tag {
      background: ${props => props.theme.productSelector.reviewColorDark};
    }
  }

  [class*='item'] {
    margin: 0;
    display: block;
    ${props => props.isLivBrite ? `
      font-size: 18px;
    ` : `
      font-size: 16px;
    `}
  }

  .item {
    &__shipment {
      margin: 0 0 8px;
    }

    &__price {
      font: ${font('default', 'bold', '22px/1')};
    }

    &__price-label {
      margin: 5px 0 0;
    }

    &__packs {
      padding: 0 20px;
      margin-top: 5px;
    }

    &__tag {
      background: ${props => props.theme.palette.general.greyLight};
      padding: 8px;
      margin-top: 10px;
    }
  }
`

export const OptionsWrapper = styled(FlexWrapper)`
  justify-content: space-between;

  @media (max-width: ${BREAKPOINT.MD}) {
    flex-wrap: wrap;
    justify-content: center;
  }

  > div {
    flex: 1;
  }
`

export const CustomizationWrapper = styled(FlexWrapper)`
  padding: 0 15px;
  ${bp('lg')`
    flex-wrap: wrap;

    > div {
      flex-grow: 1;
    }
  `}

  h2 {
    font: ${font('default', 'bold', '18px/1.2')};
    color: ${props => props.theme.palette.primary.betaLight};
  }
`

export const CustomizeWrapper = styled(FlexWrapper)<any>`
  flex-direction: column;
  width: 60%;
  margin-right: 7%;

  label {
    display: block;
    margin: 10px 0 5px;
    font: ${font('default', 'normal', '14px/1.5')};
    ${props => props.isLivBrite && `
      font-size: 18px;
    `}
  }

  .note {
    margin: 37px 0 30px !important;
    font: ${font('default', 'normal', '15px/1.5')};
  }

  strong {
    font: ${font('default', 'bold', '14px/1')};
    ${props => props.isLivBrite && `
      font-size: 18px;
    `}
  }
`

export const SubscriptionWrapper = styled.div`
  width: 45%;
  max-width: 140px;

  > p {
    margin-top: 10px !important;
  }
`
